import React, { useState, useEffect, useMemo } from "react";
import { MantineReactTable, MRT_ColumnDef } from "mantine-react-table";
import {
  superuserGetOrganizationStatistics,
  superuserGetOrganizationGetAll,
  HEADERS,
} from "../api";
import axios from "axios";

function DashboardSuperAdmin() {
  const [loading, setLoading] = useState(true);
  const [orgStats, setOrgStats] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(0);
  useEffect(() => {
    const fetchOrganizationStatistics = async () => {
      try {
        const response = await axios.post(
          superuserGetOrganizationStatistics,
          {},
          { headers: HEADERS }
        );

        if (response.data?.data?.length) {
          setOrgStats(response.data.data[0]);
        } else {
          console.warn("Unexpected stats format");
        }
      } catch (error) {
        console.error("Error fetching organization statistics:", error);
      }
    };

    fetchOrganizationStatistics();
  }, []);
  useEffect(() => {
    const fetchOrganizationGetAll = async () => {
      try {
        const response = await axios.post(
          superuserGetOrganizationGetAll,
          {},
          { headers: HEADERS }
        );

        if (response.data?.data?.length) {
          console.log("Organization Details:", response.data.data);
          setTableData(response.data.data); // <-- populate state
        } else {
          console.warn("Unexpected stats format");
        }
      } catch (error) {
        console.error("Error fetching organization statistics:", error);
      }
    };

    fetchOrganizationGetAll();
  }, []);

  const columns = [
    {
      accessorKey: "organization_id",
      header: "Organization ID",
    },
    {
      accessorKey: "organization_name",
      header: "Organization Name",
    },
    {
      accessorKey: "is_active",
      header: "Active",
      Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
    },
    {
      accessorKey: "subscription_plan_name",
      header: "Subscription Plan",
    },
    {
      accessorKey: "subscription_start_date",
      header: "Start Date",
    },
    {
      accessorKey: "subscription_start_time",
      header: "Start Time",
    },
  ];

  const paginatedData = useMemo(() => {
    const start = page * pageSize;
    return tableData.slice(start, start + pageSize);
  }, [tableData, page, pageSize]);

  const startRow = page * pageSize + 1;
  const endRow = Math.min((page + 1) * pageSize, tableData.length);
  const totalRows = tableData.length;

  const handlePageChange = (newPage) => setPage(newPage);
  const handlePageSizeChange = (newSize) => {
    setPage(0);
    setPageSize(newSize);
  };

  return (
    <div>
      <span className="title">Dashboard</span>
      <div className="row stat-row p-3">
        <div className="col-sm row-stat border rounded d-flex align-items-center justify-content-between">
          <div className="">
            <h6>Total Org</h6>
          </div>
          <div className="stat-box">
            <h4>{orgStats?.grand_total_org ?? "-"}</h4>
          </div>
        </div>
        <div className="col-sm row-stat border rounded d-flex align-items-center justify-content-between">
          <div className="stat-box">
            <h6>Total Users</h6>
          </div>
          <div className="stat-box">
            <h4>{orgStats?.grand_total_user ?? "-"}</h4>
          </div>
        </div>

        <div className="col-sm row-stat border rounded d-flex align-items-center justify-content-between">
          <div className="stat-box">
            <h6>Active Org</h6>
          </div>
          <div className="stat-box">
            <h4>{orgStats?.no_of_active_org ?? "-"}</h4>
          </div>
        </div>
        <div className="col-sm row-stat border rounded d-flex align-items-center justify-content-between">
          <div className="stat-box">
            <h6>Free</h6>
          </div>
          <div className="stat-box">
            <h4>{orgStats?.no_of_free_plan ?? 0}</h4>
          </div>
        </div>
        <div className="col-sm row-stat border rounded d-flex align-items-center justify-content-between">
          <div className="stat-box">
            <h6>Pro</h6>
          </div>
          <div className="stat-box">
            <h4>{orgStats?.no_of_pro_plan ?? 0}</h4>
          </div>
        </div>
        <div className="col-sm row-stat border rounded d-flex align-items-center justify-content-between">
          <div className="stat-box">
            <h6>Enterprise</h6>
          </div>
          <div className="stat-box">
            <h4>{orgStats?.no_of_enterprise_plan ?? 0}</h4>
          </div>
        </div>
      </div>

      <MantineReactTable
        columns={columns}
        data={paginatedData}
        enableFullScreenToggle={false}
        mantineTableBodyCellProps={{
          style: {
            backgroundColor: "#C8E3EC60",
            color: "#505050",
            border: "0.5px solid #fff",
            padding: "10px",
          },
        }}
        mantineTableHeadCellProps={{
          style: {
            backgroundColor: "#2d7d9f",
            fontSize: "14px",
            fontWeight: 500,
            color: "#fff",
            border: "1px solid #fff",
          },
        }}
        mantineTableBodyRowProps={(row) => ({
          style: {
            backgroundColor: row.index % 2 === 0 ? "#f9f9f9" : "#fff",
          },
        })}
        enablePagination={false}
        enableColumnOrdering
        manualPagination
        pageCount={Math.ceil(tableData.length / pageSize)}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        state={{ pageIndex: page, pageSize }}
      />

      <div className="pagination-container border p-2 d-flex flex-wrap justify-content-between align-items-center gap-3">
        <div className="d-flex align-items-center gap-2">
          <span style={{ fontSize: "14px" }}>Items per page:</span>
          <select
            className="form-select"
            style={{ width: "110px" }}
            value={pageSize}
            onChange={(e) => handlePageSizeChange(parseInt(e.target.value))}
          >
            <option value={5}>5 rows</option>
            <option value={10}>10 rows</option>
            <option value={20}>20 rows</option>
            <option value={50}>50 rows</option>
            <option value={100}>100 rows</option>
          </select>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <span style={{ fontSize: "14px" }}>
            {totalRows === 0
              ? "Showing 0 to 0 of 0 entries"
              : `Showing ${startRow} - ${endRow} of ${totalRows} entries`}
          </span>
        </div>
        <div className="d-flex justify-content-center align-items-center gap-3">
          <button
            className="previous-button"
            onClick={() => handlePageChange(page - 1)}
            disabled={page === 0}
          >
            Previous
          </button>
          <button
            className="add-button text-center justify-content-center"
            style={{ width: "100px" }}
            onClick={() => handlePageChange(page + 1)}
            disabled={(page + 1) * pageSize >= tableData.length}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default DashboardSuperAdmin;
